<template>
<div class="grid"  @click="edit">
<div class="col-3 md:col-2">
<p class="click_edit_value_title">{{title}}:</p>
</div>


<template v-if="editing">
<div class="col-9 md:col-10 mt-3">
<div class="grid" >
<div class="col">



<MultiSelect v-model="inputdata" :options="options" optionLabel="name"  optionValue="id" class="w-full p-inputtext-sm custom-chips-wrap"  filter   :display="showchips">


</MultiSelect>

</div>
<div class="col-fixed " style="width:110px">
<Button type="button"  icon="pi pi-check" @click="submitChanges" class="p-button-primary p-button-outlined p-button-sm mr-2"  :loading="$store.state.ui.submitting" />
<Button type="button"  icon="pi pi-times" @click="cancel" class="p-button-danger p-button-outlined p-button-sm "  :loading="$store.state.ui.submitting" />
</div>
</div>
</div>
</template>

<template v-if="!editing">	
<div class="col-9 md:col-10">
<p class="click_edit_value">
<Tag 
class="mr-2  custom-chip mb-2" 
v-for=" item in value"  
:value="item[theloopkey]"

/>
</p>
</div>
</template>

</div>	
</template>

<script>
export default {

  name: 'ClickEditMultiSelect',
  props:["title","value","valkey","options","loopkey","showaschips"],
  data () {
    return {
    	editing:false,
    	inputdata:[],
    }
  },
  computed:{
    showchips()
    {
      if(this.showaschips)
      {
        return "chip"
      }
      return "comma"
    },
    theloopkey()
    {
      if(this.loopkey)
      {

        return this.loopkey
      }
      else
      {
        return "name"
      }
    }
  },
  watch:{
  	value(nevVal,oldVal)
  	{
  		  console.log("value")
        console.log(this.value)
  		 this.editing = false
  	}
  },
  methods:{
  	submitChanges()
  	{
      this.$emit("dataChanged",{value:this.inputdata,key:this.valkey})
  		if(this.inputdata !==this.value)
  		{
  			
  			//this.cancel()
  		}
  		else
  		{
  			this.cancel()
  		}
  		
  	},
  	edit()
  	{
  		this.editing = true
      let arr = []
      for(let item of this.value)
      {
        arr.push(item.id)
      }
  		this.inputdata = arr
  		
  		setTimeout(()=>{
  			if(this.$refs.inputarea)
  			{
  				this.$refs.inputarea.$el.focus()
  			}
  			
  		},10)
  		
  	},
  	cancel()
  	{
  		setTimeout(()=>{
  			this.editing = false
  		},10)
  		
  	},

  }
};
</script>

<style lang="css" scoped>
  .custom-chips-wrap.p-multiselect-chip .p-multiselect-token{
    background-color: #352f8d;
  }
  .custom-chip{
    background-color: #352f8d;
    color: #fff;
    font-size: .75rem;
    border-radius: 3px;
    padding: 0rem 0.4rem;
    font-weight: bold;
  }
</style>